
export default function shoppingCartMobile () {
  return {
    methods: {
      openDrawer () {
        document.getElementById('overlay').classList.add('overlay-fade-in')
        document.getElementById('drawerPlaceholder').classList.add('drawerPlaceholderDown')
        document.getElementById('drawer').classList.add('drawerUp')
      },
      closeDrawer () {
        document.getElementById('overlay').classList.remove('overlay-fade-in')
        document.getElementById('drawerPlaceholder').classList.remove('drawerPlaceholderDown')
        document.getElementById('drawer').classList.remove('drawerUp')
      }
    }
  }
}
